<template>
    <div class="w-full surface-100 pt-4 pb-6 xl:pb-8">
        <div class="center px-2 xl:pl-4 xl:pr-4">
            <div class="p-2 main_title text-800 text-center align-items-center font-semibold 
                mb-3 xl:mb-5 lg:mb-5 md:mb-4 
                text-4xl xl:text-7xl lg:text-7xl md:text-6xl sm:text-6xl">
                {{ content[lang_].question_title }}
            </div>
            <div class="w-full relative align-items-center text-center">
                <div v-for="(tab, index) of tabs" class="inline-block shadow-0 surface-0 
                    mb-2 mr-2 xl:mb-3 xl:mr-3
                    py-2 pl-2 pr-1 xl:pl-3 xl:pr-2 
                    border-round-xl xl:border-round-xl lg:border-round-xl
                    cursor-pointer"
                    @click="to_answer(index)">
                    <span class="white-space-nowrap text-600
                        text-sm xl:text-lg lg:text-lg md:text-md sm:text-lg">
                        {{ tab[lang_].short }}
                    </span>
                    <span class="pi pi-angle-right text-500 ml-1 text-sm"></span>
                </div>
            </div>
        </div>
        <div class="w-full flex justify-content-center mt-4">
            <Button :label="content[lang_].button" class="flex px-5 surface-0 border-round-lg" variant="text" severity="info" @click="show_faq()" />
        </div> 
    </div>	
</template>

<script>
import faq_json from '@/assets/json/faq.json'
export default {
    data() {
        return {
            tabs: [],
            content: {
				en: {
					question_title: "FAQ",
					button: "All answers"
				} ,
				ru: {
					question_title: "Вопрос-ответ",
					button: "Все ответы"
				},
			}, 
        }
    },
    methods: {
        loadFaq() {
            this.tabs = faq_json.slice(0, 10)
        },
        show_faq() {
			this.$router.push({
				path: '/support/faq/'
			})
		},
        to_answer(val){
            this.$router.push({
                path: '/support/faq/',
                query: {
                    tab: val
                }
            })
        }
    },
    computed: {
        lang_() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
        }
    },
    async mounted() {
		this.loadFaq() 
	}
}
</script>